export const telHref = (value) => {
  if (value) {
    // keep only digits
    return `tel:${value.replace(/\D+/g, '')}`;
  }
};
